<template>
  <div class="login-form">
    <form @submit.prevent="signIn" :class="{ error }">
      <input v-model="email" placeholder="Email" type="email">
      <input v-model="password" placeholder="Password" type="password">
      <button>{{ label }}</button>
    </form>
    <a href="javascript:void(0)" class="switch" @click="signupMode = !signupMode">Switch to {{ oppositeLabel }}</a>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: "LoginForm",
    data () {
      return {
        signupMode: false,
        email: '',
        password: '',
        error: null,
      }
    },
    computed: {
      label () {
        return this.signupMode ? 'Sign Up' : 'Login'
      },
      oppositeLabel () {
        return this.signupMode ? 'Login' : 'Sign Up'
      }
    },
    methods: {
      ...mapActions(['userSignIn', 'userSignUp']),
      signIn () {
        this.error = this.signupMode ? this.userSignUp({email: this.email, password: this.password}) : this.userSignIn({email: this.email, password: this.password})
        setTimeout(() => {
          this.error = false
        }, 1000)
      },
    }
  }
</script>

<style scoped lang="sass">
@keyframes error
  10%, 90%
    transform: translate3d(-1px, 0, 0)

  20%, 80%
    transform: translate3d(2px, 0, 0)

  30%, 50%, 70%
    transform: translate3d(-4px, 0, 0)

  40%, 60%
    transform: translate3d(4px, 0, 0)

.login-form
  +full-size-fixed
  +flex-center
  gap: 48gem

  form
    +flex-center
    gap: 24gem

    &.error
      animation: error .8s cubic-bezier(.36,.07,.19,.97) both

  input
    direction: ltr
    width: 100%

  .switch
    font-size: .85em
</style>
